import { TaxYear } from "../types/taxYear";

export const getTaxYears = (taxYears: TaxYear[]) => {
    return taxYears.filter(year => year.active).map(year => year.year);
};

export const getCurrentTaxYear = (taxYears: TaxYear[]) => {
    return taxYears.filter(year => year.current).map(year => year.year)[0] || "2024/2025";
};
